import http from "../../shared/utils/http";

export const loginCall = (userData: any) => http.post<{token: string; user: any}>(`login`, userData,
    {headers: {
        'Content-Type': 'application/json'
        }})

export const resetRequestCall = (userData: any) => http.post<{email: string}>(`resetpassword`, userData,
    {headers: {
        'Content-Type': 'application/json'
        }})
